import { generateGenericWebPageSchema } from "./generators";
import { JsonLdScript } from "./JsonLdScript";
import type { SchemaWebPage } from "./types";

export interface WebPageSchemaProps {
  name: string;
  pageUrl: string;
  description?: string;
  mainEntity?: SchemaWebPage["mainEntity"];
}

export function WebPageSchema({ name, pageUrl, description, mainEntity }: WebPageSchemaProps) {
  const schema = generateGenericWebPageSchema({ name, pageUrl, description, mainEntity });

  return <JsonLdScript schema={schema} />;
}
